export const siteInfo = {
  name: '51电影网',
  slogan: '影视吃瓜第一站，独家黑料每日更新',
  tagline: '你的电影圈八卦情报中心',
  description: '51电影网专注影视吃瓜爆料，每日追踪电影圈最新内幕、明星八卦、未公开片段及争议事件。从剧组秘辛到明星私料，从删减片段到行业黑幕，我们为你带来最劲爆、最真实、最及时的影视圈独家揭秘。',
  introParagraphs: [
    '51电影网是中文互联网最硬核的影视吃瓜社区，每日追踪电影圈最新内幕与明星八卦。我们拥有一线剧组信源和资深娱记人脉，为你扒出那些被公关压下来的猛料——从大导演片场发飙到顶流明星合同纠纷，从被删减的敏感片段到票房造假的行业内幕。',
    '这里有别处看不到的独家揭秘：剧组内部的权力游戏、明星真实的片酬数字、被剪辑刀下救回的争议镜头，以及那些因为各种原因永远无法公映的电影背后故事。无论你是资深影迷还是吃瓜路人，这里都有让你瞠目结舌的猛料。',
  ],
  stats: [
    { label: '每日更新', value: '24h 不间断' },
    { label: '独家爆料', value: '2000+ 条' },
    { label: '覆盖影人', value: '500+ 位' },
  ],
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '独家爆料', href: '#cards' },
  { label: '视频拆解', href: '#media' },
  { label: '关于我们', href: '#about' },
  { label: '最新动态', href: '#updates' },
];

export const topics = [
  { tag: '票房造假', heat: '9.8万讨论', desc: '暑期档多部影片被曝注水刷票房，院线经理实名举报', color: 'primary' },
  { tag: '导演互撕', heat: '8.2万讨论', desc: '两大名导隔空对骂，新片撞档火药味十足', color: 'accent' },
  { tag: '明星塌房', heat: '12.6万讨论', desc: '顶流小生深夜密会曝光，粉丝集体脱粉回踩', color: 'primary' },
  { tag: '剧本泄露', heat: '6.4万讨论', desc: '某漫改大片完整剧本遭内部流出，剧情神反转', color: 'secondary' },
  { tag: '片酬揭秘', heat: '7.1万讨论', desc: '一线明星最新片酬单曝光，数字令人咋舌', color: 'accent' },
  { tag: '剪辑争议', heat: '5.3万讨论', desc: '上映版与导演剪辑版差异巨大，谁动了电影', color: 'primary' },
  { tag: '替身内幕', heat: '4.8万讨论', desc: '当红打星被曝用替身超90%，动作戏全是替身完成', color: 'secondary' },
  { tag: '合约纠纷', heat: '6.9万讨论', desc: '某女星因番位问题罢演，剧组紧急换角', color: 'accent' },
  { tag: '海外翻拍', heat: '3.7万讨论', desc: '国产片翻拍好莱坞经典遭遇滑铁卢，口碑崩塌', color: 'secondary' },
  { tag: '奥斯卡内幕', heat: '8.9万讨论', desc: '评委亲曝投票黑幕，获奖名单早有内定', color: 'primary' },
];

export const faqs = [
  {
    q: '51电影网的爆料来源可靠吗？',
    a: '我们的每一条爆料都经过多方信源交叉验证，团队核心成员来自前娱乐媒体资深记者和影视行业内部人士。我们对信息真实性有着严格的三级审核机制：信源核实、证据链比对、法律风险评估。虽然部分爆料因涉及敏感信息不便公开信源身份，但我们始终坚持「宁可不发，也不发假」的原则。',
  },
  {
    q: '为什么有些内容过几天就看不到了？',
    a: '影视圈的公关力量非常强大。部分爆料在发布后可能会接到相关方的删除要求或律师函。我们会在法律框架内尽量保留内容，但某些涉及正在进行的诉讼或人身安全风险的内容，可能会被临时下架。建议你关注我们的社交媒体账号获取实时动态。',
  },
  {
    q: '如何投稿或提供线索？',
    a: '我们欢迎所有影视行业从业者和知情人士提供线索。你可以通过页面底部的联系方式匿名投稿，我们承诺严格保护爆料人的身份信息。对于重大独家爆料，我们还会提供丰厚的线索奖励。点击下方「联系我们」模块了解具体投稿方式。',
  },
  {
    q: '51电影网的内容更新频率是怎样的？',
    a: '我们保持 7×24 小时不间断运营。每天早上 9 点更新当日头条爆料，下午 3 点发布深度拆解长文，晚上 8 点推送晚间快讯合集。遇到重大突发事件时，我们会在 30 分钟内完成核实并发布，确保你永远不错过任何一颗影视圈的「大瓜」。',
  },
];

export const updates = [
  {
    time: '2 小时前',
    title: '《暗夜追踪》导演与制片人片场爆发激烈冲突，拍摄中断三天',
    tag: '独家',
    tagColor: 'primary',
  },
  {
    time: '5 小时前',
    title: '某贺岁档喜剧片被曝剧本抄袭韩国电影，编剧团队集体沉默',
    tag: '热议',
    tagColor: 'accent',
  },
  {
    time: '8 小时前',
    title: '三大视频平台被指联合压价，中小制片方联名抵制',
    tag: '深度',
    tagColor: 'secondary',
  },
  {
    time: '12 小时前',
    title: '知名导演新作因涉及敏感话题被要求大幅修改，上映延期',
    tag: '独家',
    tagColor: 'primary',
  },
  {
    time: '昨天 18:30',
    title: '某男星被拍到夜店狂欢至凌晨，次日缺席新片发布会',
    tag: '快讯',
    tagColor: 'accent',
  },
  {
    time: '昨天 14:00',
    title: '好莱坞大片中文配音版被吐槽「翻译车祸」，字幕组发声',
    tag: '热议',
    tagColor: 'secondary',
  },
  {
    time: '昨天 09:30',
    title: '金鸡奖提名名单提前泄露，多位评委表示「震惊」',
    tag: '独家',
    tagColor: 'primary',
  },
  {
    time: '前天 21:00',
    title: '某古装剧拍摄现场发生安全事故，剧组被曝隐瞒不报',
    tag: '追踪',
    tagColor: 'accent',
  },
  {
    time: '前天 15:00',
    title: '动画电影行业掀起罢工潮，薪酬待遇问题浮出水面',
    tag: '深度',
    tagColor: 'secondary',
  },
];

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20avatar%20portrait%20with%20casual%20style%2C%20clean%20background%2C%20natural%20lighting%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3 分钟前',
    content: '这个剧组的料我早就听说了！我一个朋友就在那个组里当场务，说实际情况比报道的还要离谱十倍。导演骂人已经是日常操作了，关键是有个制片人还克扣群演的盒饭钱...',
    likes: 1283,
    tag: '内部人士',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20woman%20portrait%20with%20modern%20style%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20stylish%20casual%20look&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '影迷小辣椒',
    time: '15 分钟前',
    content: '终于有人扒这个导演了！我忍他很久了。上一部电影拍成那样还天天吹自己是艺术家，结果花絮里全是用替身和抠图，笑死。建议小编深扒一下他的学历造假问题。',
    likes: 867,
    tag: '资深影迷',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Asian%20man%20portrait%20with%20professional%20look%2C%20simple%20background%2C%20confident%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '圈内老炮',
    time: '42 分钟前',
    content: '在这个圈子里混了十五年，我可以说这篇文章90%的内容都是真实的。补充一个细节：那个制片人不止克扣群演，还虚报场地费，多出来的钱全进了自己腰包。这种事在这个行业太常见了。',
    likes: 2056,
    tag: '业内人士',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20trendy%20style%2C%20minimal%20background%2C%20warm%20smile%2C%20natural%20makeup&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜追剧人',
    time: '1 小时前',
    content: '好家伙，我说怎么那部剧突然停更了，原来是因为这个！平台还发公告说「技术原因」，笑死。不过说实话，演员也是人，受不了高强度拍摄也可以理解，毕竟现在剧组压榨演员的事太多了。',
    likes: 534,
    tag: '追剧达人',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20with%20intellectual%20style%2C%20simple%20background%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '独立思考者',
    time: '2 小时前',
    content: '理性分析一下：这个事件背后其实反映的是整个行业的通病——资本过度介入创作。投资方为了控制成本什么都干得出来，导演夹在中间也很难做。不过这不是为谁洗白，该骂的还是要骂。希望这个行业能越来越规范吧。',
    likes: 921,
    tag: '理性吃瓜',
  },
];

export const ranking = [
  {
    rank: 1,
    title: '2025暑期档票房黑幕全揭秘',
    category: '行业黑料',
    heat: '🔥 15.8万',
    change: 'up',
    image: 'https://readdy.ai/api/search-image?query=Dark%20movie%20theater%20interior%20with%20dramatic%20red%20lighting%2C%20empty%20seats%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%2C%20film%20noir%20style%2C%20suspenseful%20mood&width=400&height=240&seq=rank-01&orientation=landscape',
  },
  {
    rank: 2,
    title: '某顶流明星合同纠纷完整时间线',
    category: '明星八卦',
    heat: '🔥 13.2万',
    change: 'up',
    image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20contracts%20on%20a%20dark%20desk%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20style%2C%20red%20accents&width=400&height=240&seq=rank-02&orientation=landscape',
  },
  {
    rank: 3,
    title: '未公开导演剪辑版：被删减的真相',
    category: '未公开片段',
    heat: '🔥 11.6万',
    change: 'up',
    image: 'https://readdy.ai/api/search-image?query=Film%20editing%20room%20with%20vintage%20equipment%2C%20film%20strips%20hanging%2C%20warm%20cinematic%20lighting%2C%20creative%20workspace%2C%20movie%20post%20production%20atmosphere&width=400&height=240&seq=rank-03&orientation=landscape',
  },
  {
    rank: 4,
    title: '好莱坞大片中国特供版背后交易',
    category: '影视内幕',
    heat: '🔥 9.4万',
    change: 'down',
    image: 'https://readdy.ai/api/search-image?query=Hollywood%20sign%20with%20Chinese%20elements%20fusion%2C%20dramatic%20cinematic%20lighting%2C%20cultural%20contrast%2C%20film%20industry%20concept&width=400&height=240&seq=rank-04&orientation=landscape',
  },
  {
    rank: 5,
    title: '替身演员的血泪史：高危无保障',
    category: '剧组内幕',
    heat: '🔥 8.7万',
    change: 'up',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20movie%20set%20with%20stunt%20equipment%2C%20dramatic%20lighting%2C%20action%20movie%20atmosphere%2C%20professional%20cinematography&width=400&height=240&seq=rank-05&orientation=landscape',
  },
  {
    rank: 6,
    title: '网大乱象：粗制滥造背后的资本游戏',
    category: '争议电影',
    heat: '🔥 7.3万',
    change: 'same',
    image: 'https://readdy.ai/api/search-image?query=Low%20budget%20film%20production%20set%20with%20chaotic%20atmosphere%2C%20behind%20scenes%20messy%20workspace%2C%20dramatic%20cinematic%20lighting&width=400&height=240&seq=rank-06&orientation=landscape',
  },
];

export const carouselItems = [
  {
    title: '《深海迷雾》导演剪辑版独家解析',
    desc: '上映版被剪掉的37分钟里到底藏了什么？我们拿到了完整剧本，还原那些被「优化」掉的关键剧情。',
    image: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20mist%20cinematic%20scene%20with%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20dramatic%20blue%20and%20orange%20lighting%2C%20suspenseful%20movie%20poster%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '深度解析',
    tagColor: 'primary',
  },
  {
    title: '当红小花背后的资本推手全揭秘',
    desc: '从默默无闻到一线顶流，她背后的资源网络有多深？我们梳理了完整的资本版图。',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20backstage%20area%20with%20sparkling%20curtains%2C%20movie%20star%20silhouette%2C%20dramatic%20stage%20lighting%2C%20glamorous%20yet%20mysterious%20cinematic%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '独家揭秘',
    tagColor: 'accent',
  },
  {
    title: '2025年被雪藏的5部争议电影',
    desc: '这些电影拍完了却永远无法上映，原因一个比一个离谱。有的涉及政治敏感，有的得罪了行业大佬。',
    image: 'https://readdy.ai/api/search-image?query=Locked%20film%20vault%20with%20chains%2C%20old%20movie%20reels%20collecting%20dust%2C%20dramatic%20shadows%2C%20forgotten%20cinema%20atmosphere%2C%20mysterious%20and%20eerie&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '重磅专题',
    tagColor: 'primary',
  },
  {
    title: '影视圈#MeToo：那些被压下去的指控',
    desc: '多位匿名业内人士首次发声，讲述这个行业里不为人知的权力压迫与性骚扰黑幕。',
    image: 'https://readdy.ai/api/search-image?query=Silhouetted%20figure%20standing%20alone%20on%20a%20dark%20stage%2C%20single%20spotlight%2C%20powerful%20and%20emotional%20cinematic%20photography%2C%20brave%20and%20solemn%20mood&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '勇敢发声',
    tagColor: 'accent',
  },
  {
    title: '电影审查制度变迁：从过去到现在',
    desc: '一部电影从拍摄到上映要过多少关？我们用十年数据还原中国电影审查的完整演变。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20censorship%20office%20with%20stamps%20and%20documents%2C%20old%20wooden%20desk%2C%20warm%20cinematic%20lighting%2C%20historical%20movie%20industry%20atmosphere&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '深度专题',
    tagColor: 'secondary',
  },
];

export const cards = [
  {
    title: '《长安秘闻》导演被曝片场暴力倾向，多名演员私下抱怨',
    image: 'https://readdy.ai/api/search-image?query=Intense%20film%20director%20shouting%20on%20movie%20set%2C%20dramatic%20lighting%2C%20chaotic%20atmosphere%2C%20behind%20the%20scenes%20tension%2C%20cinematic%20documentary%20style&width=600&height=400&seq=card-01&orientation=landscape',
    excerpt: '据多位剧组内部人员透露，该导演在拍摄期间多次对演员和工作人员进行言语暴力，导致两名副导演中途辞职...',
    tag: '剧组内幕',
    time: '3 小时前',
  },
  {
    title: '某投资过亿大片上映一周即撤档，亏损超过5亿',
    image: 'https://readdy.ai/api/search-image?query=Empty%20movie%20theater%20with%20red%20seats%2C%20lonely%20atmosphere%2C%20dim%20lighting%2C%20failed%20box%20office%20concept%2C%20melancholic%20cinematic%20photography&width=600&height=400&seq=card-02&orientation=landscape',
    excerpt: '这部被寄予厚望的视效大片在首周末票房惨淡后紧急撤档，投资方已启动内部追责程序。业内人士分析，问题出在...',
    tag: '争议电影',
    time: '6 小时前',
  },
  {
    title: '知名编剧实名举报制片人侵吞稿费，金额超千万',
    image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20screenplay%20pages%20scattered%20on%20desk%2C%20dramatic%20lighting%2C%20tense%20atmosphere%2C%20crime%20investigation%20vibe&width=600&height=400&seq=card-03&orientation=landscape',
    excerpt: '编剧协会已介入调查，涉事制片人曾参与多部票房破十亿的热门影片。被侵吞的稿费涉及至少三部已上映电影的编剧团队...',
    tag: '行业黑料',
    time: '9 小时前',
  },
  {
    title: '明星私教曝猛料：某影帝健身全靠「科技」，人设崩塌',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fitness%20gym%20with%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20empty%20weight%20room%2C%20celebrity%20workout%20space%2C%20cinematic%20style&width=600&height=400&seq=card-04&orientation=landscape',
    excerpt: '该影帝一直以自律健身人设吸粉无数，但前私教透露其完美身材背后有着不为人知的秘密。多位健身圈内人证实了这一说法...',
    tag: '明星爆料',
    time: '12 小时前',
  },
  {
    title: '三大电影节选片人被指收受贿赂，多部入围影片存疑',
    image: 'https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20with%20dark%20shadows%2C%20corruption%20theme%2C%20dramatic%20cinematic%20lighting%2C%20prestigious%20event%20with%20hidden%20secrets&width=600&height=400&seq=card-05&orientation=landscape',
    excerpt: '国际电影节的光鲜背后暗流涌动。多位匿名消息人士证实，部分影片的入围资格并非完全依靠艺术水准，选片环节存在金钱交易...',
    tag: '影视内幕',
    time: '昨天',
  },
  {
    title: '女演员自曝被要求「潜规则」换取角色，引行业震动',
    image: 'https://readdy.ai/api/search-image?query=Single%20spotlight%20on%20empty%20stage%2C%20brave%20and%20vulnerable%20atmosphere%2C%20dramatic%20theater%20lighting%2C%20powerful%20emotional%20cinematic%20scene&width=600&height=400&seq=card-06&orientation=landscape',
    excerpt: '这位曾在多部热播剧中担任配角的女演员在社交平台发文，详细描述了试镜过程中遭遇的不当要求，引发广泛讨论和多位同行声援...',
    tag: '明星八卦',
    time: '昨天',
  },
  {
    title: '动作片替身揭秘：主角「亲自上阵」的宣传全是谎言',
    image: 'https://readdy.ai/api/search-image?query=Stunt%20double%20performing%20dangerous%20action%20scene%20on%20movie%20set%2C%20dramatic%20explosive%20lighting%2C%20behind%20the%20scenes%20action%20movie%20photography&width=600&height=400&seq=card-07&orientation=landscape',
    excerpt: '一位从业十年的替身演员匿名接受采访，揭露了动作电影宣传中关于主演「不用替身」的普遍谎言，以及替身行业面临的残酷现实...',
    tag: '未公开片段',
    time: '前天',
  },
];

export const mediaItems = [
  {
    title: '【独家拆解】《影舞者》被删减的15分钟到底拍了什么',
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20editing%20timeline%20with%20dramatic%20scenes%2C%20cinematic%20color%20grading%2C%20behind%20the%20scenes%20footage%20frame%2C%20professional%20video%20editing%20atmosphere&width=640&height=360&seq=media-01&orientation=landscape',
    desc: '我们找到了该片的原始剧本和分镜图，逐个镜头还原那些在审查中被删掉的争议内容。',
    duration: '18:42',
    views: '23.8万',
    tag: '深度拆解',
  },
  {
    title: '【片场偷拍】某大制作剧组混乱管理实况',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chaotic%20film%20set%20with%20crew%20members%20running%2C%20dramatic%20behind%20the%20scenes%2C%20cinematography%20documentary%20style%2C%20handheld%20camera%20aesthetic&width=640&height=360&seq=media-02&orientation=landscape',
    desc: '一段据称从该剧组流出的手机拍摄视频显示，片场管理极度混乱，安全问题令人担忧。',
    duration: '05:31',
    views: '18.5万',
    tag: '独家偷拍',
  },
  {
    title: '【动画揭秘】用数据告诉你电影票房如何被操纵',
    thumbnail: 'https://readdy.ai/api/search-image?query=Data%20visualization%20of%20movie%20box%20office%20numbers%2C%20animated%20charts%2C%20dark%20background%20with%20colorful%20graphs%2C%20investigative%20journalism%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape',
    desc: '通过动画数据可视化，清晰展示幽灵场、买票房、偷票房等常见票房造假手法的运作机制。',
    duration: '12:09',
    views: '31.2万',
    tag: '数据图解',
  },
];

export const appInfo = {
  title: '51电影网 APP — 吃瓜更快一步',
  desc: '独家爆料推送快人一步，离线也能刷，暗黑模式保护双眼。下载 APP 解锁「深度长文」专属板块和「爆料线索」匿名投稿通道。',
  features: ['实时推送', '暗黑模式', '匿名投稿', '离线阅读'],
  qrImage: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20film%20reel%20pattern%2C%20dark%20background%2C%20modern%20tech%20aesthetic%2C%20clean%20geometric%20design&width=280&height=280&seq=app-qr&orientation=squarish',
};

export const features = [
  {
    icon: 'ri-spy-line',
    title: '独家爆料',
    desc: '一线信源直通，每天为你扒出娱乐圈最劲爆的独家猛料，别处绝对看不到。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '三重核实',
    desc: '每一条爆料都经过信源核实、证据比对、法律风控三级审核，宁缺毋滥。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '重大突发事件30分钟内核实发布，7×24小时不间断追踪影视圈最新动态。',
  },
  {
    icon: 'ri-ghost-line',
    title: '匿名保护',
    desc: '严格保护每一位爆料人身份信息，多层加密技术确保你的隐私安全万无一失。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '深度拆解',
    desc: '不止爆料，更有专业影视人帮你解读每条八卦背后的行业逻辑和利益博弈。',
  },
];

export const aboutInfo = {
  title: '关于51电影网',
  paragraphs: [
    '51电影网成立于2023年，是国内领先的影视娱乐深度爆料平台。我们的团队由前娱乐媒体资深记者、影视行业从业者和数据调查专家组成，致力于打破娱乐圈的信息壁垒，为普通观众提供一个了解影视行业真实面貌的窗口。',
    '在这个流量为王、公关至上的时代，大部分娱乐新闻都经过了层层包装和美化。51电影网坚持做那个「说真话的孩子」——我们不制造谣言，只揭示被掩盖的真相；我们不煽动对立，只呈现被隐藏的事实。每一篇报道背后，都有扎实的信源和严谨的核实流程。',
    '我们的愿景是：让每一个热爱电影的人，都能看到这个行业的完整面貌——既有聚光灯下的璀璨，也有幕布背后的阴影。吃瓜不是目的，了解真相才是。欢迎加入51电影网，一起做清醒的吃瓜人。',
  ],
  stats: [
    { number: '2000+', label: '独家爆料' },
    { number: '500+', label: '覆盖影人' },
    { number: '300万+', label: '月活用户' },
    { number: '98.7%', label: '内容真实率' },
  ],
};

export const indexItems = [
  {
    title: '导演黑名单',
    desc: '那些被业内拉黑的「问题导演」',
    icon: 'ri-user-unfollow-line',
    count: 23,
    color: 'primary',
  },
  {
    title: '票房悬案',
    desc: '数字背后的造假与洗钱疑云',
    icon: 'ri-money-dollar-circle-line',
    count: 18,
    color: 'accent',
  },
  {
    title: '删减档案',
    desc: '那些被永久删除的争议镜头',
    icon: 'ri-scissors-cut-line',
    count: 35,
    color: 'primary',
  },
  {
    title: '替身真相',
    desc: '动作明星的真实替身使用率',
    icon: 'ri-body-scan-line',
    count: 14,
    color: 'secondary',
  },
  {
    title: '剧本泄露',
    desc: '那些意外流出的电影完整剧本',
    icon: 'ri-file-paper-2-line',
    count: 11,
    color: 'accent',
  },
  {
    title: '片酬密码',
    desc: '一线到十八线的真实收入阶梯',
    icon: 'ri-bank-card-line',
    count: 28,
    color: 'primary',
  },
  {
    title: '选角黑幕',
    desc: '角色背后不为人知的交易与博弈',
    icon: 'ri-user-search-line',
    count: 19,
    color: 'secondary',
  },
  {
    title: '海外对比',
    desc: '中外电影工业差距的真实数据',
    icon: 'ri-global-line',
    count: 16,
    color: 'accent',
  },
  {
    title: '行业潜规则',
    desc: '影视圈新人必知的生存法则',
    icon: 'ri-alert-line',
    count: 31,
    color: 'primary',
  },
];

export const contactInfo = {
  title: '联系我们 / 匿名投稿',
  desc: '如果你是影视行业从业者或知情人士，欢迎通过以下方式匿名提供线索。我们承诺严格保护爆料人身份，重大独家爆料更有丰厚奖励。',
  tips: [
    { icon: 'ri-mail-line', text: '爆料邮箱：tips@51movie.com（加密通道）' },
    { icon: 'ri-smartphone-line', text: '加密消息：Signal / Session 应用内搜索 51Movie' },
    { icon: 'ri-shield-keyhole-line', text: '你的身份信息将受多层加密保护，永不泄露' },
  ],
};

export const footerInfo = {
  description: '51电影网 — 影视吃瓜第一站。专注电影黑料、明星八卦、剧组内幕与未公开片段，每日更新最劲爆独家爆料，做清醒的吃瓜人。',
  links: [
    { label: '独家爆料', href: '#cards' },
    { label: '视频拆解', href: '#media' },
    { label: '关于我们', href: '#about' },
    { label: '最新动态', href: '#updates' },
    { label: '联系我们', href: '#contact' },
  ],
  copyright: '© 2025 51电影网 51movie.com 版权所有',
};